export const asAdmin = {
  data: `<svg width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
<path d="M1 4.25C1 4.6875 1.3125 5 1.75 5H13V6.5C13 7.1875 13.7812 7.5 14.25 7.03125L16.75 4.53125C17.0625 4.25 17.0625 3.78125 16.75 3.5L14.25 1C13.7812 0.5 13 0.84375 13 1.5V3H1.75C1.3125 3 1 3.34375 1 3.75V4.25ZM16.25 9H5V7.5C5 6.84375 4.1875 6.5 3.71875 7L1.21875 9.5C0.90625 9.78125 0.90625 10.25 1.21875 10.5312L3.71875 13.0312C4.1875 13.5 5 13.1875 5 12.5V11H16.25C16.6562 11 17 10.6875 17 10.25V9.75C17 9.34375 16.6562 9 16.25 9Z"/>
</svg>
`,
  name: 'admin',
};
